<template>
    <span class="modal-container">
        <span data-balloon="Share Project" data-balloon-pos="up">
            <button class="share simple" @click="open"><i class="fa fa-user-plus"></i></button>
        </span>
        <div class="remodal" :data-remodal-id="modalID">
            <div class="modal">
                <div v-if="showUsers">
                    <h3>Shared Access</h3>
                    <p>
                        Share <strong>{{title}}</strong> with another user. Enter an email address. <br>
                        If they have an account on the ASC-ES website we'll share access to this project with their account.
                    </p>

                    <p v-if="error" class="error" v-text="error" v-cloak></p>
                    <p v-if="success" class="success" v-text="success" v-cloak></p>

                    <div class="flex">
                        <div class="input">
                            <label for="">Email Address</label>
                            <input type="email" name="email" v-model="email">
                        </div>
                        <div class="submit">
                            <button type="submit" @click="addUser">Share with User</button>
                        </div>
                    </div>
                    <div v-if="hasUsers" v-cloak>
                        <table>
                            <tr>
                                <th>User</th>
                                <th>Email</th>
                                <th class="text-center" colspan="2">Actions</th>
                            </tr>
                            <tr v-for="user in users">
                                <td v-text="user.name"></td>
                                <td v-text="user.email"></td>
                                <td class="text-center actions">
                                    <a @click.prevent="removeUser(user.id, user.email)" data-balloon="Remove User" data-balloon-pos="up"><i class="fa fa-remove"></i></a> 
                                </td>
                                <td class="text-center actions">
                                    <a v-if="user.id" @click.prevent="confirmTransfer(user.id)" data-balloon="Transfer Ownership" data-balloon-pos="up" ><i class="fa fa-exchange"></i></a>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                    
                <div v-if="newOwner">
                    <h3>Transfer Project Administration</h3>

                    <p v-if="success" class="success" v-text="success" v-cloak></p>
                    <div v-else>
                        <p>
                            Are you sure you want to transfer administrator privileges to user <strong v-text="newOwner.name"></strong> [<em v-text="newOwner.email"></em>]?
                        </p>
                        <p class="info">Warning: You will be given shared access to create and edit submittals but you won't be able to manage this project any more!</p>
                        <button  @click="cancelTransfer" class="remodal-cancel simple">Cancel</button>
                        <button @click="transferProject" class="remodal-confirm simple">Yes, transfer this project</button>
                    </div>
                </div>
            </div>
            <button data-remodal-action="close" class="remodal-close simple"></button>
        </div>
    </span>
</template>

<script>
    import axios from 'axios';
    import Modal from 'vue/common/_modal';
    import {mapActions} from 'vuex'

    export default {
        data(){
            return {
                ownerId: null,
                email: null,
                error: null,
                success: null,
                users: []
            }
        },
        computed: {
            modalID() {
                return `${this.id}-share`
            },
            item() {
                return {
                    id: this.id,
                    url: this.url
                }
            },
            hasUsers() {
                return this.users.length > 0;
            },
            showUsers() {
                return (this.ownerId == null);
            },
            newOwner() {
                if (this.ownerId != null) {
                    let i = 0;

                    for (i = 0; i < this.users.length; i++) {
                        if (this.users[i].id == this.ownerId) {
                            return this.users[i];
                        }
                    }
                }

                return false;
            }
        },
        methods: {
            setMessage(type, message) {
                if (type == 'error') {
                    this.error = message;
                }
                if (type == 'success') {
                    this.success = message;
                }

                setTimeout(() => this.clearMessages(), 8000);
            },
            clearMessages() {
                this.error = null;
                this.success = null;
            },
            confirmTransfer(userId) {
                this.ownerId = userId;
            },
            cancelTransfer() {
                this.ownerId = null;
            },
            transferProject() {
                this.clearMessages();

                let _self = this;

                let form = new FormData();
                form.append('project_id', this.id);
                form.append('user_id', this.ownerId);

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/project/transfer-project',
                    data: form
                })
                .then(response => {
                    //console.log(response.data);
                    _self.setMessage('success', response.data.success);
                    //_self.ownerId = null;
                    //_self.getUsers();
                })
                .catch(error => {
                    //console.log(error.response);
                    _self.setMessage('error', error.response.data);
                });
            },
            addUser() {
                this.clearMessages();

                let _self = this;

                let form = new FormData();
                form.append('project_id', this.id);
                form.append('user_email', this.email);
                
                axios({
                    method: 'post',
                    url: '/actions/anvil-module/project/share-project',
                    data: form
                })
                .then(response => {
                    //console.log(response.data);
                    _self.setMessage('success', response.data.success);
                    _self.email = null;
                    _self.getUsers();
                })
                .catch(error => {
                    //console.log(error.response);
                    _self.setMessage('error', error.response.data);
                });
            },
            removeUser(userId, userEmail) {
                this.clearMessages();

                var _self = this;

                let form = new FormData();
                form.append('project_id', this.id);
                form.append('user_id', userId);
                form.append('user_email', userEmail);

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/project/unshare-project',
                    data: form
                })
                .then(response => {
                    //console.log(response.data);
                    _self.setMessage('success', response.data.success);
                    _self.getUsers();
                })
                .catch(error => {
                    //console.log(error.response);
                    _self.setMessage('error', error.response.data);
                });
            },
            getUsers() {
                var _self = this;

                let params = {
                    project_id: this.id
                };

                axios({
                    method: 'get',
                    url: '/actions/anvil-module/project/shared-users',
                    params: params
                })
                .then(response => {
                    if (response.data.length >= 1) {
                        _self.users = response.data;
                    }
                });
            }
        },
        extends: Modal,
        mounted() {
            this.getUsers();
        },
        props: {
            id: {
                type: String
            },
            title: {
                type: String
            },
            tooltip: {
                default: "Share Project",
                type: String
            }
        }
    }
</script>